import api from "./api";
import { LowStockResponse } from "../types/mrpTypes";

const mrp_base = "/mrp";

export const mrpService = {
  list: async (): Promise<LowStockResponse> => {
    const response = await api.get(`${mrp_base}/low_stock`);
    return response.data;
  },
};
